module.exports = __webpack_public_path__ + "static/media/item_9_3_comp.31b1c400.png";